import { OneEyeService } from './api'


const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const getTransactionList = async () => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Transactions`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const createTransaction = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/api/Transactions
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const updateTransaction = async (req) => {
    try {
        return await OneEyeService.put(`${krtiWebUrl}/api/Transactions/${req.id}
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}
export const deleteTransaction = async (req) => {
    try {
        return await OneEyeService.delete(`${krtiWebUrl}/api/Transactions/${req.id}
        `, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getTransactionListByProjectId = async (req,projectId) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Transactions/projects/${projectId}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getAllProjectTransaction= async (req) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Transactions/projects/`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const GetMerchantCategory = async (selectedMerchant) => {

    try {
        return await OneEyeService.get(`${krtiWebUrl}/category/getmerchantCategory/${selectedMerchant}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}
export const GetTransactionDetailsById = async (id) => {

    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Transactions/${id}
        `)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}